export const chartOptions = (chartSeries) => ({
  chart: {
    id: 'basic-bar',
    toolbar: { show: false },
    zoom: { enabled: false },
    height: 150,
  },
  xaxis: {
    type: 'numeric',
    labels: {
      show: false,
      style: {
        colors: '#727272',
        fontFamily: 'Roboto',
        fontWeight: 700,
      },
    },
    axisBorder: {
      show: true,
    },
    axisTicks: {
      show: false,
    },
    tooltip: {
      enabled: false,
    },
    crosshairs: {
      show: true,
      position: 'back',
      stroke: {
        color: '#727272',
        width: 1,
        dashArray: 0,
      },
    },
  },
  yaxis: {
    labels: { show: false },
    axisBorder: {
      show: false,
    },
  },
  grid: { show: false },
  stroke: {
    curve: 'smooth',
  },
  colors: ['#E87400', '#d07000'],
  fill: {
    type: 'gradient',
    gradient: {
      type: 'horizontal',
      shadeIntensity: 0.01,
      inverseColors: false,
      stops: [0, 70, 100],
    },
  },
  tooltip: {
    custom({ seriesIndex, dataPointIndex, w }) {
      const dadosTooltip = chartSeries[0].originalData;
      const intervalo = w.globals.initialSeries[seriesIndex].data.length;

      const dadosFiltrados = dadosTooltip.filter((item, index) => {
        return index >= dadosTooltip.length - intervalo;
      });

      const data = dadosFiltrados[dataPointIndex];

      return `<p class="chart-tooltip">${data
        .toString()
        .replace('.', ',')}%</p>`;
    },
  },
});
